export class Offer {
    public SNo: string = "";
    public Name: string = "";
    public OfferSummary: string = "";     
    public phoneNumber: string = ""; 
    public Address: string = ""; 
    public city: string = "";    
    public EmailId: string = "";  
    public Website: string = "";
    public BulletPoint1: string = "";
    public BulletPoint2: string = "";
    public BulletPoint3: string = "";
    public BulletPoint4: string = "";
    public BulletPoint5: string = "";
    public ProspectusPath: string = "";
    public Category: string = "";
    public DocumentName: string = "";
}